// import components
import { styled, Box } from '@mui/material';

// import types
import { StyledDrawerBoxProps } from './TableCRUDLayout.types';

export const StyledDrawerBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'drawerWidth'
})<StyledDrawerBoxProps>(({ drawerWidth, theme }) => ({
  height: '100%',
  width: drawerWidth ?? theme.spacing(100),
  display: 'flex',
  flexDirection: 'column'
}));
